import {useDispatch} from "react-redux"
import useHover from "../../../hooks/useOnHover"
import {useEffect, useState} from "react"
import {closeInstruction, openInstruction} from "../../../reducers/instructionVidsTreeSlice"
import {IconButton} from "@mui/material"
import {AddRounded, RemoveRounded} from "@mui/icons-material"

export default function InstructionsVidToggleIcon({instruction, index}) {
	const dispatch = useDispatch()
	const [hoverRef, isHovered] = useHover()
	const [isOpening, setIsOpening] = useState(false)

	const handleClick = () => {
		if(instruction.open) {
			dispatch(closeInstruction(index))
		}
	}

	useEffect(() => {
		let timer
		if (!instruction.open && !isOpening && isHovered) {
			setIsOpening(true)
			timer = setTimeout( () => {
				dispatch(openInstruction(index))
				setIsOpening(false)
			}, 400)
		}
		if(!instruction.open && isOpening && !isHovered) {
			timer = setTimeout( () => {
				setIsOpening(false)
			}, 100)
		}
		return () => {
			if (timer) {
				clearTimeout(timer)
			}
		}
	}, [isHovered])

	return (
		<IconButton
			ref={hoverRef}
			variant={"toggle-children"}
			sx={{alignSelf: "inherit",}}
			className={isOpening ? "loading-article-children" : null}
			onClick={handleClick}
		>
			{instruction.open ? (<RemoveRounded />) : (<AddRounded />)}
		</IconButton>
	)
}